export default __webpack_public_path__ + "static/media/javascript.c9f0a72e.svg";